import React, { useContext, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ForgotContext } from '../../contexts/ForgotContext';
import { FORGOT_ACTIONS } from './ForgotConstants';
import User from '../../models/User';
import Error from '../../utils/Error';
import { RegisterContext } from '../../contexts/RegisterContext';

const { NEXT_STEP } = FORGOT_ACTIONS;

export const ForgotStep2: React.FC = () => {
	const { t } = useTranslation();
	const { phone, code, setCode, setUsername, setSessionId } = useContext(RegisterContext);
	const { dispatch, setLoading } = useContext(ForgotContext);
	const [errorMessage, setErrorMessage] = useState(null);

	const validateCode = useCallback(
		async (e) => {
			e.preventDefault();

			setLoading(true);

			const response = await User.resetPasswordValidateCode(phone, code);

			if (response.isSuccess() && response.data) {
				setLoading(false);
				setUsername(response.data.username);
				setSessionId(response.data.sessionId);
				setErrorMessage(null);

				dispatch({ type: NEXT_STEP });
			} else {
				setLoading(false);
				setCode(null);
				setUsername(null);
				setSessionId(null);
				setErrorMessage(Error.getErrorMessage(response.getErrorCode()));
			}
		},
		[code, dispatch, phone, setCode, setLoading, setSessionId, setUsername]
	);

	const onCodeChange = useCallback((e) => setCode(e.target.value.trim()), [setCode]);

	return (
		<form className={'forgot-password-form-step-2 form-large'} onSubmit={validateCode}>
			<div className={'message'}>{t('Forgot.Step2.Message')}</div>
			{errorMessage && <div className={'alert alert-danger'}>{errorMessage}</div>}
			<div className={'form-group'}>
				<label htmlFor={'forgot-step2-code'}>{t('Forgot.Step2.Code')}</label>
				<input
					id={'forgot-step2-code'}
					autoFocus
					type={'text'}
					autoCapitalize={'false'}
					autoCorrect={'false'}
					autoComplete={'one-time-code'}
					className={'form-control'}
					value={code || ''}
					onChange={onCodeChange}
				/>
			</div>
			<div className={'form-buttons'}>
				<input type={'submit'} className={'btn btn-primary'} value={String(t('Forgot.Step2.Submit'))} />
			</div>
		</form>
	);
};
